import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus2 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Plus",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M11.3621 4.66678C11.3621 4.21655 10.9971 3.85156 10.5469 3.85156C10.0966 3.85156 9.73166 4.21655 9.73166 4.66678V9.28635H5.11209C4.66186 9.28635 4.29688 9.65133 4.29688 10.1016C4.29688 10.5518 4.66186 10.9168 5.11209 10.9168H9.73166V15.5363C9.73166 15.9866 10.0966 16.3516 10.5469 16.3516C10.9971 16.3516 11.3621 15.9866 11.3621 15.5363V10.9168H15.9817C16.4319 10.9168 16.7969 10.5518 16.7969 10.1016C16.7969 9.65133 16.4319 9.28635 15.9817 9.28635H11.3621V4.66678Z",
			fill: "white"
		})
	})
});
const ForwardRef = forwardRef(SvgPlus2);
export default ForwardRef;
